var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"t-vue-lbtn",attrs:{"src":_vm.base64,"id":_vm.uuid},on:{"click":_vm.onclick}})
}
var staticRenderFns = []

export { render, staticRenderFns }